export interface Aliment {
  id: number;
  nom: string;
  categorie:
    | 'fruits'
    | 'legumes'
    | 'feculents'
    | 'legumineuses'
    | 'viandes'
    | 'poissons'
    | 'produits_laitiers'
    | 'boissons'
    | 'snacks'
    | 'desserts'
    | 'fast_food'
    | 'sauces'
    | 'petit_dejeuner'
    | 'produits_industriels';
  image: string;
  description: string;
  glucidesPour100g: number;
  calories100g: number;
  fibres100g: number;
  indexGlycemique: number;
  // Nouveaux champs nutritionnels détaillés
  proteines100g?: number;
  lipides100g?: number;
  sucres100g?: number;
  chargeGlycemique?: number;
  nutriscore?: string;
  aliases?: string[];
  source?: string;
  scoreConfiance?: number; // 1 à 5
}

export const aliments: Aliment[] = [
  {
    id: 1,
    nom: 'Pomme Gala',
    categorie: 'fruits',
    image: 'https://readdy.ai/api/search-image?query=fresh%20red%20apple%20gala%20variety%20on%20clean%20white%20background%20food%20photography%20crisp%20and%20shiny&width=400&height=300&seq=alim-fruit-1&orientation=landscape',
    description: 'Fruit sucré et croquant, riche en fibres et antioxydants. Consommer avec la peau pour maximiser l\'apport en fibres. IG modéré, privilégier les portions de 100-150g.',
    glucidesPour100g: 13.8,
    calories100g: 52,
    fibres100g: 2.4,
    indexGlycemique: 36,
    proteines100g: 0.3,
    lipides100g: 0.2,
    sucres100g: 10.4,
    chargeGlycemique: 5,
    nutriscore: 'A',
    aliases: ['pomme rouge', 'apple', 'malus domestica'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 2,
    nom: 'Banane mûre',
    categorie: 'fruits',
    image: 'https://readdy.ai/api/search-image?query=ripe%20yellow%20banana%20bunch%20on%20clean%20white%20background%20food%20photography%20vibrant%20and%20fresh&width=400&height=300&seq=alim-fruit-2&orientation=landscape',
    description: 'Fruit énergétique riche en potassium et vitamine B6. Plus la banane est mûre, plus son IG est élevé. À consommer en portions contrôlées pour les diabétiques.',
    glucidesPour100g: 22.8,
    calories100g: 89,
    fibres100g: 2.6,
    indexGlycemique: 51,
    proteines100g: 1.1,
    lipides100g: 0.3,
    sucres100g: 12.2,
    chargeGlycemique: 12,
    nutriscore: 'B',
    aliases: ['banane cavendish', 'plantain doux'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 3,
    nom: 'Myrtilles',
    categorie: 'fruits',
    image: 'https://readdy.ai/api/search-image?query=fresh%20blueberries%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20berries&width=400&height=300&seq=alim11&orientation=landscape',
    description: 'Fruit à faible index glycémique, riche en antioxydants et vitamines. Excellent choix pour les diabétiques.',
    glucidesPour100g: 14,
    calories100g: 57,
    fibres100g: 2.4,
    indexGlycemique: 25,
    proteines100g: 0.7,
    lipides100g: 0.3,
    sucres100g: 10.0,
    chargeGlycemique: 4,
    nutriscore: 'A',
    aliases: ['bleuets', 'blueberries', 'vaccinium'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 4,
    nom: 'Fraises',
    categorie: 'fruits',
    image: 'https://readdy.ai/api/search-image?query=fresh%20red%20strawberries%20on%20clean%20white%20background%20food%20photography%20glossy%20and%20ripe&width=400&height=300&seq=alim-fruit-4&orientation=landscape',
    description: 'Fruit rouge très faible en glucides, riche en vitamine C et antioxydants. Parfait pour les desserts légers des diabétiques.',
    glucidesPour100g: 7.7,
    calories100g: 32,
    fibres100g: 2.0,
    indexGlycemique: 41,
    proteines100g: 0.7,
    lipides100g: 0.3,
    sucres100g: 4.9,
    chargeGlycemique: 3,
    nutriscore: 'A',
    aliases: ['fragaria', 'strawberry'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 5,
    nom: 'Brocoli',
    categorie: 'legumes',
    image: 'https://readdy.ai/api/search-image?query=fresh%20broccoli%20florets%20on%20white%20background%20food%20photography%20clean%20healthy%20green%20vegetable&width=400&height=300&seq=alim8&orientation=landscape',
    description: 'Légume crucifère très faible en glucides, riche en vitamines C et K, fibres et antioxydants. Excellent allié pour les diabétiques.',
    glucidesPour100g: 7,
    calories100g: 34,
    fibres100g: 2.6,
    indexGlycemique: 15,
    proteines100g: 2.8,
    lipides100g: 0.4,
    sucres100g: 1.7,
    chargeGlycemique: 1,
    nutriscore: 'A',
    aliases: ['brassica oleracea', 'chou brocoli'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 6,
    nom: 'Épinards',
    categorie: 'legumes',
    image: 'https://readdy.ai/api/search-image?query=fresh%20spinach%20leaves%20on%20white%20background%20food%20photography%20clean%20healthy%20green%20vegetable&width=400&height=300&seq=alim9&orientation=landscape',
    description: 'Légume feuille très faible en glucides, riche en fer, magnésium et vitamines. Idéal pour les diabétiques.',
    glucidesPour100g: 3.6,
    calories100g: 23,
    fibres100g: 2.2,
    indexGlycemique: 15,
    proteines100g: 2.9,
    lipides100g: 0.4,
    sucres100g: 0.4,
    chargeGlycemique: 1,
    nutriscore: 'A',
    aliases: ['spinach', 'spinacia oleracea'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 7,
    nom: 'Tomates cerises',
    categorie: 'legumes',
    image: 'https://readdy.ai/api/search-image?query=cherry%20tomatoes%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20red%20vegetables&width=400&height=300&seq=alim14&orientation=landscape',
    description: 'Légume-fruit faible en glucides, riche en lycopène et vitamine C. Parfait pour agrémenter les salades.',
    glucidesPour100g: 3.9,
    calories100g: 18,
    fibres100g: 1.2,
    indexGlycemique: 15,
    proteines100g: 0.9,
    lipides100g: 0.2,
    sucres100g: 2.6,
    chargeGlycemique: 1,
    nutriscore: 'A',
    aliases: ['tomate cocktail', 'pomodoro'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 8,
    nom: 'Carottes cuites',
    categorie: 'legumes',
    image: 'https://readdy.ai/api/search-image?query=cooked%20sliced%20carrots%20on%20white%20plate%20food%20photography%20clean%20orange%20healthy%20vegetable&width=400&height=300&seq=alim-leg-4&orientation=landscape',
    description: 'Légume racine riche en bêta-carotène. Cuisson à l\'eau qui augmente légèrement l\'IG par rapport à la carotte crue.',
    glucidesPour100g: 8.1,
    calories100g: 35,
    fibres100g: 3.0,
    indexGlycemique: 39,
    proteines100g: 0.8,
    lipides100g: 0.2,
    sucres100g: 5.2,
    chargeGlycemique: 3,
    nutriscore: 'A',
    aliases: ['carotte vapeur', 'daucus carota'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 9,
    nom: 'Quinoa cuit',
    categorie: 'feculents',
    image: 'https://readdy.ai/api/search-image?query=quinoa%20grains%20in%20white%20bowl%20close%20up%20food%20photography%20clean%20white%20background%20healthy%20grain&width=400&height=300&seq=alim3&orientation=landscape',
    description: 'Pseudo-céréale complète riche en protéines et acides aminés essentiels. Index glycémique modéré, excellent substitut au riz.',
    glucidesPour100g: 21.3,
    calories100g: 120,
    fibres100g: 2.8,
    indexGlycemique: 53,
    proteines100g: 4.4,
    lipides100g: 1.9,
    sucres100g: 0.9,
    chargeGlycemique: 11,
    nutriscore: 'A',
    aliases: ['chenopodium quinoa', 'quinoa blanc'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 10,
    nom: 'Riz basmati cuit',
    categorie: 'feculents',
    image: 'https://readdy.ai/api/search-image?query=basmati%20rice%20in%20white%20bowl%20close%20up%20food%20photography%20clean%20white%20background%20healthy%20grain&width=400&height=300&seq=alim5&orientation=landscape',
    description: 'Riz à grains longs avec un index glycémique plus bas que le riz blanc classique. À consommer en portions contrôlées.',
    glucidesPour100g: 23.0,
    calories100g: 111,
    fibres100g: 0.4,
    indexGlycemique: 58,
    proteines100g: 2.1,
    lipides100g: 0.3,
    sucres100g: 0.1,
    chargeGlycemique: 13,
    nutriscore: 'B',
    aliases: ['oryza sativa', 'riz long grain'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 11,
    nom: 'Patate douce cuite',
    categorie: 'feculents',
    image: 'https://readdy.ai/api/search-image?query=sweet%20potato%20sliced%20on%20white%20background%20food%20photography%20clean%20healthy%20vegetable&width=400&height=300&seq=alim4&orientation=landscape',
    description: 'Féculent à index glycémique modéré, riche en bêta-carotène et fibres. Meilleure alternative à la pomme de terre.',
    glucidesPour100g: 20.7,
    calories100g: 86,
    fibres100g: 3.3,
    indexGlycemique: 44,
    proteines100g: 1.6,
    lipides100g: 0.1,
    sucres100g: 6.5,
    chargeGlycemique: 9,
    nutriscore: 'A',
    aliases: ['batate', 'ipomoea batatas', 'sweet potato'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 12,
    nom: 'Pâtes blanches cuites al dente',
    categorie: 'feculents',
    image: 'https://readdy.ai/api/search-image?query=italian%20pasta%20spaghetti%20cooked%20al%20dente%20in%20white%20bowl%20food%20photography%20clean&width=400&height=300&seq=alim-fec-4&orientation=landscape',
    description: 'Cuisson al dente recommandée car elle abaisse l\'IG par rapport à une cuisson prolongée. Associer avec des légumes et protéines.',
    glucidesPour100g: 25.0,
    calories100g: 131,
    fibres100g: 1.8,
    indexGlycemique: 49,
    proteines100g: 5.0,
    lipides100g: 1.1,
    sucres100g: 0.6,
    chargeGlycemique: 12,
    nutriscore: 'B',
    aliases: ['spaghetti', 'penne', 'triticum durum'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 13,
    nom: 'Lentilles vertes cuites',
    categorie: 'legumineuses',
    image: 'https://readdy.ai/api/search-image?query=green%20lentils%20in%20white%20bowl%20close%20up%20food%20photography%20clean%20white%20background%20healthy%20legumes&width=400&height=300&seq=alim1&orientation=landscape',
    description: 'Légumineuse riche en protéines et fibres. Excellent pour stabiliser la glycémie grâce à son index glycémique très bas.',
    glucidesPour100g: 20,
    calories100g: 116,
    fibres100g: 8,
    indexGlycemique: 29,
    proteines100g: 9.0,
    lipides100g: 0.4,
    sucres100g: 1.8,
    chargeGlycemique: 6,
    nutriscore: 'A',
    aliases: ['lentille du puy', 'lens culinaris'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 14,
    nom: 'Pois chiches cuits',
    categorie: 'legumineuses',
    image: 'https://readdy.ai/api/search-image?query=chickpeas%20in%20white%20bowl%20close%20up%20food%20photography%20clean%20white%20background%20healthy%20legumes&width=400&height=300&seq=alim2&orientation=landscape',
    description: 'Légumineuse polyvalente, source de protéines végétales et de fibres. Idéale pour les diabétiques.',
    glucidesPour100g: 27.4,
    calories100g: 164,
    fibres100g: 7.6,
    indexGlycemique: 33,
    proteines100g: 8.9,
    lipides100g: 2.6,
    sucres100g: 4.8,
    chargeGlycemique: 9,
    nutriscore: 'A',
    aliases: ['garbanzo', 'cicer arietinum', 'pois chiche'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 15,
    nom: 'Haricots rouges cuits',
    categorie: 'legumineuses',
    image: 'https://readdy.ai/api/search-image?query=red%20kidney%20beans%20cooked%20in%20white%20bowl%20food%20photography%20clean%20healthy%20legumes&width=400&height=300&seq=alim-legum-3&orientation=landscape',
    description: 'Légumineuse riche en fibres solubles qui ralentissent l\'absorption des glucides. Excellente pour le contrôle glycémique.',
    glucidesPour100g: 22.8,
    calories100g: 127,
    fibres100g: 6.4,
    indexGlycemique: 24,
    proteines100g: 8.7,
    lipides100g: 0.5,
    sucres100g: 0.3,
    chargeGlycemique: 5,
    nutriscore: 'A',
    aliases: ['haricot rouge', 'phaseolus vulgaris'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 16,
    nom: 'Blanc de poulet cuit',
    categorie: 'viandes',
    image: 'https://readdy.ai/api/search-image?query=chicken%20breast%20cooked%20sliced%20on%20white%20background%20food%20photography%20clean%20healthy%20protein%20meat&width=400&height=300&seq=alim-viande-1&orientation=landscape',
    description: 'Viande blanche maigre, excellente source de protéines de haute qualité. Zéro glucide, idéale pour les repas équilibrés des diabétiques.',
    glucidesPour100g: 0,
    calories100g: 165,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 31.0,
    lipides100g: 3.6,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['escalope de poulet', 'chicken breast', 'filet de poulet'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 17,
    nom: 'Bœuf maigre cuit',
    categorie: 'viandes',
    image: 'https://readdy.ai/api/search-image?query=lean%20beef%20steak%20grilled%20on%20white%20plate%20food%20photography%20clean%20healthy%20protein%20meat%20red&width=400&height=300&seq=alim-viande-2&orientation=landscape',
    description: 'Viande rouge maigre, excellente source de protéines, fer héminique et zinc. Zéro glucide. À consommer modérément.',
    glucidesPour100g: 0,
    calories100g: 250,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 26.0,
    lipides100g: 15.0,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['steak haché 5% MG', 'rumsteck', 'bifteck'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 18,
    nom: 'Dinde rôtie',
    categorie: 'viandes',
    image: 'https://readdy.ai/api/search-image?query=roasted%20turkey%20breast%20slices%20on%20white%20plate%20food%20photography%20clean%20healthy%20white%20meat&width=400&height=300&seq=alim-viande-3&orientation=landscape',
    description: 'Volaille maigre, très riche en protéines et pauvre en lipides. Excellente alternative au poulet.',
    glucidesPour100g: 0,
    calories100g: 135,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 30.1,
    lipides100g: 1.0,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['dinde blanche', 'turkey breast'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 19,
    nom: 'Saumon atlantique cru',
    categorie: 'poissons',
    image: 'https://readdy.ai/api/search-image?query=fresh%20salmon%20fillet%20on%20white%20background%20food%20photography%20clean%20healthy%20fish%20protein%20orange%20pink&width=400&height=300&seq=alim6&orientation=landscape',
    description: 'Poisson gras riche en oméga-3 (EPA/DHA), protéines et vitamine D. Zéro glucide, excellent pour la santé cardiovasculaire des diabétiques.',
    glucidesPour100g: 0,
    calories100g: 208,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 20.0,
    lipides100g: 13.4,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['salmo salar', 'saumon fumé', 'gravlax'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 20,
    nom: 'Thon albacore en boîte',
    categorie: 'poissons',
    image: 'https://readdy.ai/api/search-image?query=canned%20tuna%20flakes%20in%20white%20bowl%20food%20photography%20clean%20healthy%20fish%20protein&width=400&height=300&seq=alim-poiss-2&orientation=landscape',
    description: 'Poisson maigre riche en protéines et oméga-3. Pratique pour les repas rapides. Attention au sel ajouté dans certaines conserves.',
    glucidesPour100g: 0,
    calories100g: 132,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 23.0,
    lipides100g: 1.0,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['thon au naturel', 'thunnus alalunga', 'tuna'],
    source: 'CIQUAL 2020',
    scoreConfiance: 4,
  },
  {
    id: 21,
    nom: 'Cabillaud cuit',
    categorie: 'poissons',
    image: 'https://readdy.ai/api/search-image?query=cooked%20cod%20fillet%20white%20fish%20on%20white%20plate%20food%20photography%20clean%20healthy&width=400&height=300&seq=alim-poiss-3&orientation=landscape',
    description: 'Poisson blanc maigre, excellente source de protéines et pauvre en calories. Zéro glucide, très digeste.',
    glucidesPour100g: 0,
    calories100g: 105,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 22.8,
    lipides100g: 0.9,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['morue fraîche', 'gadus morhua', 'cod fish'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 22,
    nom: 'Yaourt grec nature',
    categorie: 'produits_laitiers',
    image: 'https://readdy.ai/api/search-image?query=greek%20yogurt%20thick%20creamy%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20dairy%20protein&width=400&height=300&seq=alim12&orientation=landscape',
    description: 'Produit laitier riche en protéines et probiotiques. Faible en glucides, excellent pour la flore intestinale.',
    glucidesPour100g: 3.6,
    calories100g: 97,
    fibres100g: 0,
    indexGlycemique: 11,
    proteines100g: 9.0,
    lipides100g: 5.0,
    sucres100g: 3.6,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['yaourt strained', 'skyr', 'greek yoghurt'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 5,
  },
  {
    id: 23,
    nom: 'Fromage blanc 0% MG',
    categorie: 'produits_laitiers',
    image: 'https://readdy.ai/api/search-image?query=fresh%20white%20cottage%20cheese%20in%20white%20bowl%20food%20photography%20clean%20healthy%20dairy%20low%20fat&width=400&height=300&seq=alim-lait-2&orientation=landscape',
    description: 'Produit laitier très pauvre en matières grasses, riche en calcium et protéines. Excellent choix pour les diabétiques.',
    glucidesPour100g: 4.0,
    calories100g: 73,
    fibres100g: 0,
    indexGlycemique: 15,
    proteines100g: 8.0,
    lipides100g: 0.2,
    sucres100g: 4.0,
    chargeGlycemique: 1,
    nutriscore: 'A',
    aliases: ['faisselle', 'fromage frais', 'cottage cheese'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 24,
    nom: 'Lait demi-écrémé UHT',
    categorie: 'produits_laitiers',
    image: 'https://readdy.ai/api/search-image?query=glass%20of%20semi%20skimmed%20milk%20on%20white%20background%20food%20photography%20clean%20healthy%20dairy&width=400&height=300&seq=alim-lait-3&orientation=landscape',
    description: 'Source de calcium et protéines. Le lait entier a un IG plus bas que le lait écrémé (contre-intuitif mais confirmé par la recherche).',
    glucidesPour100g: 4.8,
    calories100g: 46,
    fibres100g: 0,
    indexGlycemique: 37,
    proteines100g: 3.3,
    lipides100g: 1.6,
    sucres100g: 4.8,
    chargeGlycemique: 2,
    nutriscore: 'A',
    aliases: ['lait 1/2 écrémé', 'semi-skimmed milk', 'lait uht'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 25,
    nom: 'Eau plate',
    categorie: 'boissons',
    image: 'https://readdy.ai/api/search-image?query=clear%20glass%20of%20still%20water%20with%20ice%20on%20white%20background%20food%20photography%20clean%20refreshing&width=400&height=300&seq=alim-boiss-1&orientation=landscape',
    description: 'Hydratation essentielle, zéro calorie, zéro glucide. La boisson de référence pour tous les diabétiques.',
    glucidesPour100g: 0,
    calories100g: 0,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 0,
    lipides100g: 0,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['eau du robinet', 'eau minérale', 'still water'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 26,
    nom: 'Café noir sans sucre',
    categorie: 'boissons',
    image: 'https://readdy.ai/api/search-image?query=black%20coffee%20espresso%20in%20white%20ceramic%20cup%20on%20white%20background%20food%20photography%20clean&width=400&height=300&seq=alim-boiss-2&orientation=landscape',
    description: 'Boisson sans calorie, riches en antioxydants. Le café peut améliorer la sensibilité à l\'insuline à court terme selon certaines études.',
    glucidesPour100g: 0.2,
    calories100g: 2,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 0.1,
    lipides100g: 0,
    sucres100g: 0,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['espresso', 'café filtre', 'americano'],
    source: 'CIQUAL 2020',
    scoreConfiance: 5,
  },
  {
    id: 27,
    nom: 'Thé vert infusé',
    categorie: 'boissons',
    image: 'https://readdy.ai/api/search-image?query=green%20tea%20in%20transparent%20glass%20cup%20on%20white%20background%20food%20photography%20clean%20healthy&width=400&height=300&seq=alim-boiss-3&orientation=landscape',
    description: 'Boisson riche en catéchines et antioxydants. Sans calorie, sans glucide. Peut aider à la régulation glycémique.',
    glucidesPour100g: 0.2,
    calories100g: 1,
    fibres100g: 0,
    indexGlycemique: 0,
    proteines100g: 0.2,
    lipides100g: 0,
    sucres100g: 0.02,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['sencha', 'matcha', 'thé matcha', 'green tea'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 28,
    nom: 'Amandes natures',
    categorie: 'snacks',
    image: 'https://readdy.ai/api/search-image?query=raw%20almonds%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20nuts&width=400&height=300&seq=alim-snack-1&orientation=landscape',
    description: 'Fruit à coque riche en lipides insaturés, fibres, protéines et magnésium. Excellent en-cas pour les diabétiques.',
    glucidesPour100g: 9.5,
    calories100g: 579,
    fibres100g: 12.5,
    indexGlycemique: 0,
    proteines100g: 21.2,
    lipides100g: 49.9,
    sucres100g: 4.4,
    chargeGlycemique: 0,
    nutriscore: 'A',
    aliases: ['prunus dulcis', 'amande crue', 'raw almonds'],
    source: 'CIQUAL 2020 + USDA',
    scoreConfiance: 5,
  },
  {
    id: 29,
    nom: 'Noix de cajou',
    categorie: 'snacks',
    image: 'https://readdy.ai/api/search-image?query=cashew%20nuts%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20creamy%20nuts&width=400&height=300&seq=alim-snack-2&orientation=landscape',
    description: 'Fruit à coque crémeux, riche en fer, zinc et magnésium. Plus sucré que les autres fruits à coque, à consommer avec modération.',
    glucidesPour100g: 30.2,
    calories100g: 553,
    fibres100g: 3.3,
    indexGlycemique: 25,
    proteines100g: 18.2,
    lipides100g: 43.9,
    sucres100g: 5.9,
    chargeGlycemique: 8,
    nutriscore: 'A',
    aliases: ['anacardium occidentale', 'cajou', 'cashew nuts'],
    source: 'CIQUAL 2020 + USDA',
    scoreConfiance: 5,
  },
  {
    id: 30,
    nom: 'Chocolat noir 70%',
    categorie: 'snacks',
    image: 'https://readdy.ai/api/search-image?query=dark%20chocolate%2070%20percent%20cocoa%20squares%20on%20white%20background%20food%20photography%20clean%20rich%20brown&width=400&height=300&seq=alim-snack-3&orientation=landscape',
    description: 'Chocolat riche en flavonoïdes et antioxydants. Le cacao réduit l\'IG global. Choisir au minimum 70% de cacao et surveiller la portion (20-30g).',
    glucidesPour100g: 45.8,
    calories100g: 598,
    fibres100g: 10.9,
    indexGlycemique: 23,
    proteines100g: 7.9,
    lipides100g: 42.6,
    sucres100g: 24.0,
    chargeGlycemique: 11,
    nutriscore: 'C',
    aliases: ['chocolat extra', 'dark chocolate', 'cacao 70%'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 31,
    nom: 'Tiramisu',
    categorie: 'desserts',
    image: 'https://readdy.ai/api/search-image?query=tiramisu%20dessert%20slice%20in%20white%20plate%20food%20photography%20clean%20creamy%20coffee%20layers&width=400&height=300&seq=alim-dess-1&orientation=landscape',
    description: 'Dessert italien à base de mascarpone et café. Très riche en glucides et lipides. À consommer très occasionnellement et en petite portion.',
    glucidesPour100g: 29.0,
    calories100g: 354,
    fibres100g: 0.5,
    indexGlycemique: 54,
    proteines100g: 4.8,
    lipides100g: 24.0,
    sucres100g: 22.0,
    chargeGlycemique: 16,
    nutriscore: 'C',
    aliases: ['tiramisu maison', 'dessert italien'],
    source: 'OpenFoodFacts + CIQUAL estimé',
    scoreConfiance: 3,
  },
  {
    id: 32,
    nom: 'Glace vanille',
    categorie: 'desserts',
    image: 'https://readdy.ai/api/search-image?query=vanilla%20ice%20cream%20scoop%20in%20white%20bowl%20food%20photography%20clean%20creamy%20yellow%20white&width=400&height=300&seq=alim-dess-2&orientation=landscape',
    description: 'Dessert lacté sucré, très riche en sucres rapides. IG élevé. Alternative : glace au yaourt grec allégé ou sorbet sans sucres ajoutés.',
    glucidesPour100g: 23.6,
    calories100g: 207,
    fibres100g: 0.7,
    indexGlycemique: 51,
    proteines100g: 3.5,
    lipides100g: 11.0,
    sucres100g: 21.2,
    chargeGlycemique: 12,
    nutriscore: 'D',
    aliases: ['crème glacée', 'vanilla ice cream'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 33,
    nom: 'Big Mac (McDonald\'s)',
    categorie: 'fast_food',
    image: 'https://readdy.ai/api/search-image?query=classic%20cheeseburger%20on%20white%20background%20food%20photography%20clean%20sesame%20bun%20beef%20patty&width=400&height=300&seq=alim-fast-1&orientation=landscape',
    description: 'Sandwich fast-food très calorique, riche en glucides (pain), lipides et sodium. IG élevé dû au pain blanc et aux sauces sucrées. À éviter ou compenser par beaucoup de légumes.',
    glucidesPour100g: 20.1,
    calories100g: 257,
    fibres100g: 1.4,
    indexGlycemique: 66,
    proteines100g: 11.8,
    lipides100g: 14.9,
    sucres100g: 4.1,
    chargeGlycemique: 13,
    nutriscore: 'D',
    aliases: ['cheeseburger', 'hamburger', 'burger'],
    source: 'OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 34,
    nom: 'Frites classiques',
    categorie: 'fast_food',
    image: 'https://readdy.ai/api/search-image?query=french%20fries%20golden%20crispy%20in%20paper%20cone%20white%20background%20food%20photography%20clean&width=400&height=300&seq=alim-fast-2&orientation=landscape',
    description: 'Féculent frit, très riche en glucides et lipides absorbés lors de la friture. IG élevé. Alternative : frites au four avec peu d\'huile.',
    glucidesPour100g: 37.2,
    calories100g: 312,
    fibres100g: 3.0,
    indexGlycemique: 75,
    proteines100g: 3.4,
    lipides100g: 15.0,
    sucres100g: 0.3,
    chargeGlycemique: 28,
    nutriscore: 'D',
    aliases: ['frites', 'pommes frites', 'french fries'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 35,
    nom: 'Ketchup',
    categorie: 'sauces',
    image: 'https://readdy.ai/api/search-image?query=tomato%20ketchup%20in%20small%20white%20bowl%20food%20photography%20clean%20red%20sauce%20condiment&width=400&height=300&seq=alim-sauce-1&orientation=landscape',
    description: 'Sauce tomate sucrée, très riche en sucres ajoutés. Une cuillère à soupe (~15g) contient environ 4g de sucre. Attention aux portions.',
    glucidesPour100g: 26.0,
    calories100g: 112,
    fibres100g: 0.8,
    indexGlycemique: 55,
    proteines100g: 1.3,
    lipides100g: 0.2,
    sucres100g: 22.8,
    chargeGlycemique: 14,
    nutriscore: 'C',
    aliases: ['sauce tomate sucrée', 'catsup'],
    source: 'OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 36,
    nom: 'Vinaigrette allégée',
    categorie: 'sauces',
    image: 'https://readdy.ai/api/search-image?query=french%20dressing%20vinaigrette%20in%20glass%20cruet%20white%20background%20food%20photography%20clean%20golden&width=400&height=300&seq=alim-sauce-2&orientation=landscape',
    description: 'Sauce à base d\'huile et de vinaigre. Version allégée réduite en lipides. Le vinaigre de cidre peut aider à modérer la glycémie post-prandiale.',
    glucidesPour100g: 5.0,
    calories100g: 175,
    fibres100g: 0.2,
    indexGlycemique: 15,
    proteines100g: 0.3,
    lipides100g: 15.0,
    sucres100g: 3.5,
    chargeGlycemique: 1,
    nutriscore: 'B',
    aliases: ['vinaigre de cidre', 'sauce salade', 'french dressing'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 3,
  },
  {
    id: 37,
    nom: 'Flocons d\'avoine',
    categorie: 'petit_dejeuner',
    image: 'https://readdy.ai/api/search-image?query=oat%20flakes%20in%20white%20bowl%20food%20photography%20clean%20white%20background%20healthy%20grain%20breakfast&width=400&height=300&seq=alim15&orientation=landscape',
    description: 'Céréale complète riche en bêta-glucanes, fibres solubles qui ralentissent l\'absorption des glucides. Excellent choix pour le petit-déjeuner des diabétiques.',
    glucidesPour100g: 66.3,
    calories100g: 389,
    fibres100g: 10.6,
    indexGlycemique: 55,
    proteines100g: 16.9,
    lipides100g: 6.9,
    sucres100g: 0.9,
    chargeGlycemique: 36,
    nutriscore: 'A',
    aliases: ['oatmeal', 'rolled oats', 'haferflocken'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 38,
    nom: 'Pain complet aux céréales',
    categorie: 'petit_dejeuner',
    image: 'https://readdy.ai/api/search-image?query=whole%20grain%20seeded%20bread%20slice%20on%20white%20background%20food%20photography%20clean%20brown%20crust&width=400&height=300&seq=alim-pdj-2&orientation=landscape',
    description: 'Pain à base de farine complète avec graines. Plus riche en fibres que le pain blanc, ce qui abaisse l\'IG. Privilégier les pains au levain.',
    glucidesPour100g: 43.4,
    calories100g: 247,
    fibres100g: 6.5,
    indexGlycemique: 48,
    proteines100g: 9.5,
    lipides100g: 3.5,
    sucres100g: 3.8,
    chargeGlycemique: 21,
    nutriscore: 'A',
    aliases: ['pain intégral', 'vollkornbrot', 'wholemeal bread'],
    source: 'CIQUAL 2020 + Sydney GI Database',
    scoreConfiance: 5,
  },
  {
    id: 39,
    nom: 'Croissant industriel',
    categorie: 'petit_dejeuner',
    image: 'https://readdy.ai/api/search-image?query=french%20croissant%20golden%20flaky%20pastry%20on%20white%20background%20food%20photography%20clean%20butter&width=400&height=300&seq=alim-pdj-3&orientation=landscape',
    description: 'Viennoiserie très riche en beurre et farine raffinée. IG élevé, très calorique. À consommer occasionnellement et en petite portion.',
    glucidesPour100g: 45.8,
    calories100g: 406,
    fibres100g: 2.6,
    indexGlycemique: 67,
    proteines100g: 8.2,
    lipides100g: 21.0,
    sucres100g: 11.3,
    chargeGlycemique: 31,
    nutriscore: 'D',
    aliases: ['croissant beurre', 'viennoiserie', 'crescent roll'],
    source: 'CIQUAL 2020 + OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 40,
    nom: 'Nutella / Pâte à tartiner',
    categorie: 'produits_industriels',
    image: 'https://readdy.ai/api/search-image?query=chocolate%20hazelnut%20spread%20in%20white%20bowl%20food%20photography%20clean%20creamy%20brown&width=400&height=300&seq=alim-ind-1&orientation=landscape',
    description: 'Pâte à tartiner très sucrée, riche en huile de palme et sucres. 2 cuillères à café = environ 10g de sucre. À utiliser très parcimonieusement.',
    glucidesPour100g: 57.5,
    calories100g: 539,
    fibres100g: 5.4,
    indexGlycemique: 33,
    proteines100g: 6.3,
    lipides100g: 30.0,
    sucres100g: 56.3,
    chargeGlycemique: 19,
    nutriscore: 'D',
    aliases: ['pâte à tartiner', 'gianduja', 'hazelnut spread'],
    source: 'OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 41,
    nom: 'Barre chocolatée type Mars',
    categorie: 'produits_industriels',
    image: 'https://readdy.ai/api/search-image?query=chocolate%20candy%20bar%20caramel%20nougat%20on%20white%20background%20food%20photography%20clean&width=400&height=300&seq=alim-ind-2&orientation=landscape',
    description: 'Confiserie très sucrée, riche en sucres rapides et lipides. Pic glycémique important puis hypoglycémie réactive. À éviter.',
    glucidesPour100g: 68.0,
    calories100g: 452,
    fibres100g: 1.5,
    indexGlycemique: 65,
    proteines100g: 4.5,
    lipides100g: 17.0,
    sucres100g: 60.0,
    chargeGlycemique: 44,
    nutriscore: 'D',
    aliases: ['snickers', 'twix', 'barre caramel'],
    source: 'OpenFoodFacts',
    scoreConfiance: 4,
  },
  {
    id: 42,
    nom: 'Soda Coca-Cola Original',
    categorie: 'produits_industriels',
    image: 'https://readdy.ai/api/search-image?query=cola%20soda%20glass%20with%20ice%20bubbles%20on%20white%20background%20food%20photography%20clean%20dark%20caramel&width=400&height=300&seq=alim-ind-3&orientation=landscape',
    description: 'Boisson sucrée avec ~10.6g de sucres par 100ml. Un canette de 33cl = 35g de sucre. Effet glycémique immédiat et fort. À remplacer par de l\'eau gazeuse avec citron.',
    glucidesPour100g: 10.6,
    calories100g: 42,
    fibres100g: 0,
    indexGlycemique: 63,
    proteines100g: 0,
    lipides100g: 0,
    sucres100g: 10.6,
    chargeGlycemique: 7,
    nutriscore: 'E',
    aliases: ['coca', 'soda sucré', 'soft drink'],
    source: 'OpenFoodFacts',
    scoreConfiance: 5,
  },
];

export const categoriesAliments = [
  { id: 'fruits', label: 'Fruits', icon: 'ri-apple-line' },
  { id: 'legumes', label: 'Légumes', icon: 'ri-leaf-line' },
  { id: 'feculents', label: 'Féculents', icon: 'ri-bread-line' },
  { id: 'legumineuses', label: 'Légumineuses', icon: 'ri-plant-line' },
  { id: 'viandes', label: 'Viandes', icon: 'ri-restaurant-line' },
  { id: 'poissons', label: 'Poissons', icon: 'ri-drop-line' },
  { id: 'produits_laitiers', label: 'Produits laitiers', icon: 'ri-cup-line' },
  { id: 'boissons', label: 'Boissons', icon: 'ri-goblet-line' },
  { id: 'snacks', label: 'Snacks', icon: 'ri-seedling-line' },
  { id: 'desserts', label: 'Desserts', icon: 'ri-cake-3-line' },
  { id: 'fast_food', label: 'Fast-food', icon: 'ri-fire-line' },
  { id: 'sauces', label: 'Sauces', icon: 'ri-drop-fill' },
  { id: 'petit_dejeuner', label: 'Petit-déjeuner', icon: 'ri-sun-line' },
  { id: 'produits_industriels', label: 'Produits industriels', icon: 'ri-store-line' },
];